import { ReactNode } from 'react'

import { Currency } from '../../../../../types/currency'
import { DEFAULT_FORMATTER_LOCALE } from '../../../../constants/defaultFormatterLocale'
import { NumberFormat } from '../../../../utils/NumberFormat'
import { type CurrencyFormattingOptions } from '../../../../utils/NumberFormat/getCurrencyNumber'
import { FormattedElement } from '../../../elements/FormattedElement'
import { FormattedNumberProps } from '../../FormattedNumber'

export interface FormattedCurrencyNumberProps extends FormattedNumberProps {
  currency: Currency
  options?: CurrencyFormattingOptions
}

export const FormattedCurrencyNumber = ({
  as = 'span',
  asString = false,
  currency,
  locale = DEFAULT_FORMATTER_LOCALE,
  options,
  value,
}: FormattedCurrencyNumberProps): ReactNode => {
  return (
    <FormattedElement as={as} asString={asString}>
      {NumberFormat.getCurrencyNumber(value, currency, locale, options)}
    </FormattedElement>
  )
}
